var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.8675 0.5 0.5 3.8675 0.5 8C0.5 12.1325 3.8675 15.5 8 15.5C12.1325 15.5 15.5 12.1325 15.5 8C15.5 3.8675 12.1325 0.5 8 0.5ZM10.52 9.725C10.7375 9.9425 10.7375 10.3025 10.52 10.52C10.4075 10.6325 10.265 10.685 10.1225 10.685C9.98 10.685 9.8375 10.6325 9.725 10.52L8 8.795L6.275 10.52C6.1625 10.6325 6.02 10.685 5.8775 10.685C5.735 10.685 5.5925 10.6325 5.48 10.52C5.37539 10.4141 5.31672 10.2713 5.31672 10.1225C5.31672 9.97368 5.37539 9.83085 5.48 9.725L7.205 8L5.48 6.275C5.37539 6.16915 5.31672 6.02632 5.31672 5.8775C5.31672 5.72868 5.37539 5.58585 5.48 5.48C5.6975 5.2625 6.0575 5.2625 6.275 5.48L8 7.205L9.725 5.48C9.9425 5.2625 10.3025 5.2625 10.52 5.48C10.7375 5.6975 10.7375 6.0575 10.52 6.275L8.795 8L10.52 9.725Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationClose);
export default __webpack_public_path__ + "static/media/notificationClose.362a1e9d8a19719e74161f8e22f46a8a.svg";
export { ForwardRef as ReactComponent };